import { memo, type FC } from "react";
import { Modal } from "antd";
import { Check, Info } from "lucide-react";
import { useTranslation } from "react-i18next";
import { WHATSAPP_EDITOR_KEY } from "../WhatsAppCampaignConstants";

const MODAL_KEY = `${WHATSAPP_EDITOR_KEY}.form.submitted`;

interface TemplateSubmittedModalProps {
  templateName: string;
  onDone: () => void;
}

const TemplateSubmittedModal: FC<TemplateSubmittedModalProps> = ({ templateName, onDone }) => {
  const { t } = useTranslation();

  return (
    <Modal open centered footer={null} closable={false} maskClosable={false} onCancel={onDone}>
      <div className="wa-submitted">
        <span className="wa-submitted__icon" aria-hidden>
          <Check size={28} />
        </span>
        <h3 className="wa-submitted__title">{t(`${MODAL_KEY}.title`)}</h3>
        <p className="wa-submitted__description">
          {t(`${MODAL_KEY}.description`, { name: templateName })}
        </p>
        <p className="wa-template-card__notice wa-template-card__notice--info wa-submitted__note">
          <Info size={14} aria-hidden /> {t(`${MODAL_KEY}.note`)}
        </p>
        <button type="button" className="button button--primary campaign-flow__action" onClick={onDone}>
          {t(`${MODAL_KEY}.done`)}
        </button>
      </div>
    </Modal>
  );
};

export default memo(TemplateSubmittedModal);
